import React, { FC } from 'react';

import { Typography } from '@material-ui/core';
import { Box, Button, Grid, Stack } from '@mui/material';
import dynamic from 'next/dynamic';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { AestheticWaves, NativeTokenOrbital } from 'src/v2/components/ui/images';

import { useIsMobile } from '~components/hooks/utils/useIsMobile';
import { primaryColors, secondaryColors } from '~components/theme/styles/colors';
import { ENativeAsset } from '~config/types';

import SlideWrapper from '../SlideWrapper';
const MobileFadingContainer = dynamic(
  () =>
    import('src/v2/components/ui/containers/mobile').then(
      ({ MobileFadingContainer }) => MobileFadingContainer,
    ),
  { ssr: false },
);

const GatewaySection = () => {
  return (
    <Stack spacing={4} textAlign={{ xs: 'center', sm: 'left' }}>
      <Typography variant={'h4'} color={primaryColors[400]}>
        The Gateway to
      </Typography>
      <Typography variant={'h2'} color={primaryColors[100]}>
        Vesta Empire
      </Typography>
      <Typography variant={'body1'} color={primaryColors[400]}>
        Experience Unparalleled Security & Censorship-Resistance with our overcollateralized stablecoin: VST.
      </Typography>
      <Box width={'100%'}>
        <Button variant={'secondary'} sx={{ width: 310 }}>
          LEARN MORE ABOUT YOUR MOM :D
        </Button>
      </Box>
    </Stack>
  );
};

const VestaEmpireSlide: FC = () => {
  const isMobile = useIsMobile();
  return (
    <SlideWrapper sx={{ overflowX: 'hidden' }}>
      <MobileFadingContainer
        app={
          <>
            <Box sx={{ position: 'relative', left: 316, bottom: 20 }}>
              <AestheticWaves />
            </Box>

            <Grid container mb={12} mt={`-${515 / 2 + 515 / 4 + 515 / 8}px`}>
              <Grid item xs={12} sm={5} height={'400px'}>
                <Box pl={{ sm: 12, md: 18 }} pt={4}>
                  <NativeTokenOrbital asset={ENativeAsset.VSTA} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={7}>
                <GatewaySection />
              </Grid>
            </Grid>
          </>
        }
        mobile={
          <Stack alignItems={'center'} spacing={20} pt={8}>
            <NativeTokenOrbital asset={ENativeAsset.VSTA} />
            <GatewaySection />
          </Stack>
        }
      />

      <Stack justifyContent={'space-between'} mt={12} direction={{ xs: 'column', sm: 'row' }}>
        <Stack
          spacing={4}
          sx={
            isMobile
              ? { borderBottom: `1px solid ${secondaryColors[200]}`, pb: 4 }
              : { borderRight: `1px solid ${secondaryColors[200]}`, pr: '64px' }
          }
        >
          <Typography variant={'h4'} color={primaryColors[50]}>
            Staking
          </Typography>
          <Typography variant={'body1'} color={primaryColors[400]}>
            Unlock the full potential of your VSTA by staking them in the Vesta Staking Module.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
            <ButtonWithIcon iconType="asterisk" sx={{ width: 170 }}>
              START STAKING
            </ButtonWithIcon>
            <ButtonWithIcon iconType="asterisk" sx={{ width: 150 }}>
              LEARN MORE
            </ButtonWithIcon>
          </Stack>
        </Stack>
        <Stack sx={isMobile ? { pt: 4 } : { pl: '64px' }} spacing={4}>
          <Typography variant={'h4'} color={primaryColors[50]}>
            Governance
          </Typography>
          <Typography variant={'body1'} color={primaryColors[400]}>
            Your ticket to active participation in shaping the protocol through governance.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
            <ButtonWithIcon iconType="asterisk" sx={{ minWidth: 300, width: 300 }}>
              VISIT CURIA - GOVERNANCE FORUM
            </ButtonWithIcon>
            <ButtonWithIcon iconType="asterisk" sx={{ width: 180 }}>
              VISIT SNAPSHOT
            </ButtonWithIcon>
          </Stack>
        </Stack>
      </Stack>
    </SlideWrapper>
  );
};

export default VestaEmpireSlide;
